import React, { useRef, useState } from 'react';

import uploadImg from "./../../assets/images/uploadicon.svg";
import { ImageConfig } from '../../utils/ImageConfig';
import TickIcon from "./../../assets/images/tickIcon.svg";
import { Col, Row } from 'react-bootstrap';
import { Download } from "react-bootstrap-icons";

import './Upload.styles.css';

interface DropFileInputProps {
    onFileUpload: (files: File[]) => void;
    onFileDownload?: (file: string) => void;
    supportedFileTypes: Array<string>
    filesInfo: any;
    disabled: boolean;
    visible: boolean;
    sidebyside?: boolean;
    isFolderPath: boolean;
    isDocSuccess: boolean;
    isDocFail: boolean;
    infoMessage: string
}

const Docupload: React.FC<DropFileInputProps> = ({ supportedFileTypes, filesInfo, disabled, visible, sidebyside = false, isFolderPath, isDocSuccess, isDocFail, infoMessage, onFileUpload, onFileDownload }) => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const [fileList, setFileList] = useState<File[]>([]);

    const onDragEnter = () => wrapperRef.current?.classList.add('dragover');
    const onDragLeave = () => wrapperRef.current?.classList.remove('dragover');
    const onDrop = () => wrapperRef.current?.classList.remove('dragover');

    const mimeToLabel: Record<string, string> = {
        "application/pdf": "PDF",
        "image/jpeg": "JPG/JPEG",
        "image/png": "PNG"
    };

    const supportedFileTypesText = supportedFileTypes.map(type => mimeToLabel[type]).join(", ");

    const onFileDrop = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (disabled) {
            return;
        }
        const newFiles = Array.from(e.target.files || []);
        setFileList(newFiles);
        onFileUpload(newFiles);
    }

    const fileRemove = (file: File) => {
        const updatedList = fileList.filter(item => item !== file);
        setFileList(updatedList);
        // onFileChange(updatedList);
    }

    const downloadFile = (file: File) => {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return (
        <div className={`${disabled ? "row readonly-section" : 'row'}`}>
            {!disabled && <><div className={`${sidebyside ? "col-6" : 'col-12'}`}>
                {infoMessage && <div className='upload-info-msg px-2 pb-2 text-start text-muted'>{infoMessage}</div>}
                {!isDocSuccess && !isDocFail ?
                    <div
                        ref={wrapperRef}
                        className={`drop-file-input ${disabled ? 'disabled' : ''}`}
                        onDragEnter={onDragEnter}
                        onDragLeave={onDragLeave}
                        onDrop={onDrop}
                    >
                        <div className="d-flex align-items-center drop-file-input__label">
                            <img src={uploadImg} alt="Upload" />
                            <div>
                                <h2>Select documents to upload or drag & drop</h2>
                                <h4>Supported file type: {supportedFileTypesText}</h4>
                            </div>
                        </div>
                        <input
                            type="file"
                            onChange={onFileDrop}
                            multiple
                            disabled={disabled}
                        />
                    </div>
                    : <></>}

                {isDocSuccess &&
                    <div className="drop-file-input">
                        <div className="doc-status-content">
                            <svg width="100" height="100">
                                <circle
                                    fill="none"
                                    stroke="#78A22F"
                                    strokeWidth="5"
                                    cx="50"
                                    cy="50"
                                    r="45"
                                    strokeLinecap="round"
                                    transform="rotate(-40 50 50)"
                                    className="doc-status-circle"
                                />
                                <polyline
                                    fill="none"
                                    stroke="#78A22F"
                                    points="20,53 45,73 80,36"
                                    strokeWidth="5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="doc-status-tick"
                                />
                            </svg>
                            <p className="doc-status-tick-text">Document uploaded successfully.</p>
                        </div>
                    </div>
                }

                {isDocFail &&
                    <div className="drop-file-input">
                        <div className="doc-status-content">
                            <svg width="100" height="100">
                                <circle
                                    fill="none"
                                    stroke="#C43131"
                                    strokeWidth="5"
                                    cx="50"
                                    cy="50"
                                    r="45"
                                    strokeLinecap="round"
                                    transform="rotate(-40 50 50)"
                                    className="doc-status-circle"
                                />
                                <path
                                    fill="none"
                                    stroke="#C43131"
                                    strokeWidth="6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M 25,25 L 75,75 M 75,25 L 25,75"
                                    className="doc-status-cross"
                                />
                            </svg>
                            <p className="doc-status-cross-text">Document upload failed. Please try again.</p>
                        </div>
                    </div>
                }
            </div> </>}

            <div className={`${sidebyside ? "col-6" : 'col-12'}`}>
                {filesInfo?.files && filesInfo?.files.length > 0 ? (
                    <div className='car-upload-file-container drop-file-preview'>
                        <Row className="mb-2">
                            {filesInfo.files.map((item: any, index: number) => (
                                <Col key={index} md={6} className="mb-2">
                                    <div
                                        className="d-flex align-items-center justify-content-between p-2 rounded document-item"
                                        style={{ backgroundColor: "#f6f6f6" }}
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="p-1 rounded bg-white">
                                                <img className='uploadItemImage'
                                                    src={ImageConfig[item.split('/')[1]] || ImageConfig['default']}
                                                    alt={item}
                                                />
                                            </div>
                                            <div style={{ fontSize: "12px" }}>
                                                <div className="text-truncate fileName">{item}</div>
                                                <div className="text-start" style={{ fontSize: "10px", color: "gray" }}>Uploaded</div>
                                            </div>
                                        </div>
                                        {/*<img className='doc-success-tick-icon' src={TickIcon} alt={''} /> */}
                                        {onFileDownload && <>
                                            <div className="p-1">
                                                <Download title="Download" size={18} color="#78A22F" className="me-1 cursor-pointer" onClick={() => onFileDownload(item)} />
                                            </div>
                                        </>}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ) : (
                    <>
                        <div className='file-upload-empty'>
                            <p className='file-upload-main-empty text-muted'>There are no uploaded files.</p>
                            {!isFolderPath &&
                                <p className='file-upload-sub-empty text-muted'>File Upload Path Not Available.</p>
                            }
                        </div>

                    </>
                )}
            </div>
        </div>
    );
}

export default Docupload;
